import React, { Component } from "react";
import {
  TabsCustom,
  TabsCustomHeader,
  TabsCustomMenu,
  TabsCustomBody,
  TabsCustomItem,
  Nav,
  Loader,
  Button,
} from "ui-kit-ck-consultant";
import FadeIn from "react-fade-in";

import ShowOptionsNGRA from "../../../components/general/ShowOptionsNGRA-v2";
import PrintClass from "../../../components/general/Print";

import OverallDay from "../../../components/performances/overall-performance/OverallDay";
import Overall from "../../../components/performances/overall-performance/Overall";
import OverallAgency from "../../../components/performances/overall-performance/OverallAgency";

import axiosConfig from "../../../utils/axiosConfig";

import AuthContext from "../../../context/AuthContext";
import filterStore from "../../../stores/filterStore";
import moment from "moment";

export default class OverallPerformance extends Component {
  constructor(props) {
    super(props);
    const saved = filterStore.getState().getPageState("overallPerformance");
    this.state = saved || {
      // LOADERS
      isLoad: false,
      isLoadAgency: false,
      isLoadDay: false,
      isPrint: false,
      // Data
      data: null,
      agencyData: null,
      dayData: null,
      tabsIdArray: [],
      tabsId: 0,
      // ShowOption state
      network: 0,
      group: 0,
      region: 0,
      agency: 0,
      dateStart: moment().format("YYYY-01-01"),
      dateEnd: moment().format("YYYY-12-31"),
      natureEvent: [],
    };

    this.refPrintOverall = React.createRef();
    this.refPrintOverallAgency = React.createRef();
  }

  static contextType = AuthContext;

  componentDidMount() {
    this.interval = setInterval(() => {
      if (this.state.isLoad === false) {
        this.getData(false);
        this.getAgencies();
        this.getDataDay();
      }
    }, 15 * 60 * 1000);
  }

  componentWillUnmount = () => {
    clearInterval(this.interval);
    filterStore.getState().setPageState("overallPerformance", this.state);
  };

  handleDataChange = (data) => {
    filterStore.getState().setPageFilters("overallPerformance", data);
    this.setState(
      {
        network: data.network,
        group: data.group,
        region:
          data.regionMultiples && data.regionMultiples.length
            ? [...data.regionMultiples]
            : data.region,
        agency: [...data.agencyMultiples],
        dateStart: data.dateStart,
        dateEnd: data.dateEnd,
        natureEvent: data.natureEvent,
      },
      () => {
        this.getData();
        this.getAgencies();
        this.getDataDay();
      },
    );
  };

  getAgencies = () => {
    axiosConfig({
      url: "/performances/overall/get-agencies",
      data: {
        network: this.state.network,
        group: this.state.group,
        region: this.state.region,
      },
    })
      .then((res) => {
        if (res.data.success === true) {
          this.setState(
            {
              tabsIdArray: res.data.data,
              tabsId:
                res.data.data.length <= this.state.tabsId
                  ? 0
                  : this.state.tabsId,
            },
            this.getDataAgency,
          );
        } else {
          this.setState({
            tabsIdArray: [],
            tabsId: 0,
          });
        }
      })
      .catch(() => {
        this.setState({
          tabsIdArray: [],
          tabsId: 0,
        });
      });
  };

  getData = (isLoad = true) => {
    this.setState({ isLoad }, () => {
      axiosConfig({
        url: "/performances/overall/get-data",
        data: {
          network: this.state.network,
          group: this.state.group,
          region: this.state.region,
          agency: this.state.agency,
          dateStart: this.state.dateStart,
          dateEnd: this.state.dateEnd,
          natureEvent: this.state.natureEvent,
        },
      })
        .then((res) => {
          if (res.data.success === true) {
            this.setState({
              data: res.data.data,
              isLoad: false,
            });
          } else {
            this.setState({ data: null, isLoad: false });
          }
        })
        .catch(() => {
          this.setState({ data: null, isLoad: false });
        });
    });
  };

  getDataAgency = () => {
    this.setState(
      {
        isLoadAgency: true,
      },
      () => {
        axiosConfig({
          url: "/performances/overall/get-data-agency",
          data: {
            agency: this.state.tabsIdArray[this.state.tabsId]["a_id"],
            dateStart: this.state.dateStart,
            dateEnd: this.state.dateEnd,
            natureEvent: this.state.natureEvent,
          },
        })
          .then((res) => {
            if (res.data.success === true) {
              this.setState({
                agencyData: res.data.data,
                isLoadAgency: false,
              });
            } else {
              this.setState({ agencyData: null, isLoadAgency: false });
            }
          })
          .catch(() => {
            this.setState({ agencyData: null, isLoadAgency: false });
          });
      },
    );
  };

  getDataDay = () => {
    // Requête la plus lente de la page : sans ce jeton, la réponse d'un
    // périmètre précédent peut arriver après celle du périmètre demandé.
    const token = (this.dayToken = (this.dayToken || 0) + 1);

    this.setState({ isLoadDay: true }, () => {
      axiosConfig({
        url: "/performances/overall/get-data-day",
        data: {
          network: this.state.network,
          group: this.state.group,
          region: this.state.region,
          agency: this.state.agency,
          natureEvent: this.state.natureEvent,
          dateEnd: this.state.dateEnd,
        },
      })
        .then((res) => {
          if (token !== this.dayToken) return;
          this.setState({
            dayData: res.data.success === true ? res.data.data : null,
            isLoadDay: false,
          });
        })
        .catch(() => {
          if (token !== this.dayToken) return;
          this.setState({ dayData: null, isLoadDay: false });
        });
    });
  };

  getAllLastRegions = (type) => {
    this.setState({ isLoadingRegions: true });

    const config = {
      url: "/interview/get-all-last-regions",
      method: "POST",
      data: {
        year: moment(this.state.dateStart).format("YYYY"),
        network: this.state.network,
        region: this.state.region,
        type,
      },
      responseType: "blob",
    };

    axiosConfig(config)
      .then((res) => {
        if (res.data instanceof Blob) {
          const url = window.URL.createObjectURL(new Blob([res.data]));
          const link = document.createElement("a");
          link.href = url;

          const today = new Date().toISOString().split("T")[0];
          link.setAttribute("download", `donnees_regions_${today}.xlsx`);

          document.body.appendChild(link);
          link.click();

          link.remove();
          window.URL.revokeObjectURL(url);
        }
      })
      .catch((err) => {
        console.error("Erreur lors du téléchargement:", err);
        alert(
          "Une erreur s'est produite lors du téléchargement des données...",
        );
      })
      .finally(() => {
        this.setState({ isLoadingRegions: false });
      });
  };

  render() {
    return (
      <>
        <FadeIn>
          <Nav title="Performance globale" className="mb-10 mb-20-xl" />
          <ShowOptionsNGRA
            isChange={true}
            className="mb-10 mb-20-xl"
            onDataChange={this.handleDataChange}
            initialFilters={filterStore.getState().getPageFilters("overallPerformance")}
            isDateStart={true}
            isDateEnd={true}
            isGlobal={true}
            isRegionMultiples={true}
            isAgencyMultiples={true}
            isNatureEvent={true}
            visibilityRole={this.props.visibilityRole}
            visibilityType={this.props.visibilityType}
            preloadRole={this.props.preloadRole}
            preloadType={this.props.preloadType}
            limitUserType={this.props.limitUserType}
            limitUserRole={this.props.limitUserRole}
            others={
              <div
                style={{ display: "flex", flexDirection: "column", gap: 10 }}
              >
                <Button
                  className="w-auto"
                  text={
                    this.state.isLoadingRegions
                      ? "Chargement..."
                      : "Télécharger les données qualités"
                  }
                  disabled={this.state.isLoadingRegions}
                  onClick={() => {
                    this.getAllLastRegions(1);
                  }}
                />
              </div>
            }
          />
          {this.state.dayData || this.state.isLoadDay ? (
            <>
              <div
                className="mb-10"
                style={{
                  fontSize: 12,
                  color: "#1b7a43",
                  padding: "4px 10px",
                  background: "#e8f5ec",
                  borderRadius: 4,
                  display: "inline-block",
                }}
                title="Indicateurs calculés en direct depuis la base (MySQL)"
              >
                {this.state.isLoadDay
                  ? "Chargement des indicateurs temps réel…"
                  : "Indicateurs ci-dessous en temps réel"}
              </div>
              {this.state.dayData ? (
                <div style={{ opacity: this.state.isLoadDay ? 0.4 : 1 }}>
                  <OverallDay
                    data={this.state.dayData}
                    dataCAMonth={this.state?.data?.month?.CA}
                    dateEnd={this.state.dateEnd}
                  />
                </div>
              ) : null}
            </>
          ) : null}
          {this.state.data ? (
            <div ref={this.refPrintOverall}>
              {this.state.data.dataSource &&
              this.state.data.dataSource.type === "duckdb" ? (
                <div
                  className="mb-10"
                  style={{
                    fontSize: 12,
                    color: "#666",
                    padding: "4px 10px",
                    background: "#f4f6f8",
                    borderRadius: 4,
                    display: "inline-block",
                  }}
                  title="Graphiques issus de la mémoire tampon analytique (DuckDB), recalculée automatiquement. Un léger écart avec les indicateurs temps réel du haut est normal."
                >
                  Graphiques ci-dessous via mémoire tampon — données à jour au{" "}
                  {moment(this.state.data.dataSource.lastSyncAt).format(
                    "DD/MM/YYYY à HH:mm"
                  )}
                </div>
              ) : null}
              <Overall
                year={moment(this.state.dateEnd, "YYYY-MM-DD").format("YYYY")}
                data={this.state.data}
              />
            </div>
          ) : null}
          {this.state.tabsIdArray ? (
            <>
              <TabsCustom className={"mb-10 mb-20-xl "}>
                <TabsCustomHeader>
                  {this.state.tabsIdArray.map((element, key) => (
                    <TabsCustomMenu
                      key={key}
                      title={element.a_name}
                      active={this.state.tabsId === key}
                      disabled={this.state.isLoadAgency}
                      onClick={
                        !this.state.isLoadAgency
                          ? (e) => {
                              this.setState(
                                { tabsId: key },
                                this.getDataAgency,
                              );
                            }
                          : undefined
                      }
                    />
                  ))}
                </TabsCustomHeader>
                <TabsCustomBody noCard>
                  {this.state.agencyData ? (
                    <TabsCustomItem active={true}>
                      <div ref={this.refPrintOverallAgency}>
                        <OverallAgency
                          year={moment(this.state.dateEnd, "YYYY-MM-DD").format(
                            "YYYY",
                          )}
                          data={this.state.agencyData}
                        />
                      </div>
                    </TabsCustomItem>
                  ) : null}
                </TabsCustomBody>
              </TabsCustom>
            </>
          ) : null}
        </FadeIn>
        <Loader show={this.state.isLoad || this.state.isPrint} />
        <PrintClass
          refs={
            this.state.isPrint
              ? [this.refPrintOverall, this.refPrintOverallAgency]
              : []
          }
          title={"Performance globale"}
          fileName={"Performance globale"}
          onPrint={(print) => this.setState({ isPrint: print })}
          width={1600}
        />
      </>
    );
  }
}
